/** sets filters on baseQuery, by reference.
 * searchFields comes from the dataModel configuration and is shaped like
 * QueryEMX2.searchFieldsByProperty: { root: [...], <nestedBranch>: [...] } */
export async function applyFiltersToQuery(
  baseQuery,
  filters,
  facetDetails,
  filterType,
  searchFields
) {
  baseQuery.resetAllFilters();
  const activeFilters = Object.keys(filters);

  if (activeFilters.length === 0) return baseQuery;

  for (const filterKey of activeFilters) {
    const filterDetail = facetDetails[filterKey];

    const filterValue = filters[filterKey];

    switch (filterDetail.component) {
      case "StringFilter": {
        if (filterKey === "search" && filterValue) {
          baseQuery.searchValue = filterValue.replaceAll('"', "");
          baseQuery.searchFieldsByProperty = searchFields;
        } else {
          /** add filters to the provider (root) table */
          for (const field of searchFields?.root ?? []) {
            baseQuery.orWhere(field).like(filterValue);
          }

          /** and filter the nested branches */
          for (const [branch, fields] of Object.entries(searchFields ?? {})) {
            if (branch === "root") continue;
            for (const field of fields) {
              baseQuery.orFilter(`${branch}.${field}`).like(filterValue);
            }
          }
        }

        /** cant search in the search box on any filter that is set to 'adaptive' because the items will not show. */
        break;
      }
      case "ToggleFilter":
      case "ServiceFilter":
      case "CheckboxFilter": {
        const values = Array.isArray(filterValue)
          ? filterValue.map((fv) => fv.value)
          : [filterValue];
        const columns = Array.isArray(filterDetail.applyToColumn)
          ? filterDetail.applyToColumn
          : [filterDetail.applyToColumn];

        for (const column of columns) {
          if (
            filterType[filterDetail.facetIdentifier] === "all" ||
            values.length === 1
          ) {
            if (typeof values[0] === "boolean") {
              for (const value of values) {
                baseQuery.where(column).equals(value);
                baseQuery.filter(column).equals(value);
              }
            } else {
              baseQuery.where(column).in(values);
              baseQuery.filter(column).in(values);
            }
          } else {
            if (typeof values[0] === "boolean") {
              for (const value of values) {
                baseQuery.orWhere(column).equals(value);
                baseQuery.orFilter(column).equals(value);
              }
            } else {
              baseQuery.orWhere(column).in(values);
              baseQuery.orFilter(column).in(values);
            }
          }
        }
        break;
      }
      case "OntologyFilter": {
        const values = filterValue.map((filterValue) => filterValue.code);
        if (
          filterType[filterDetail.facetIdentifier] === "all" ||
          values.length === 1
        ) {
          baseQuery.where(filterDetail.applyToColumn).in(values);
          baseQuery.filter(filterDetail.applyToColumn).in(values);
        } else {
          baseQuery.orWhere(filterDetail.applyToColumn).in(values);
          baseQuery.orFilter(filterDetail.applyToColumn).in(values);
        }
        break;
      }
    }
  }
  return baseQuery;
}
